const ProductCardSkeleton = () => (
  <div className="relative p-3 bg-white border rounded-lg animate-pulse max-w">
    <div className="absolute bg-gray-200 rounded-full top-3 start-3 size-10" />
    <div className="flex items-center justify-center h-48">
      <svg
        className="text-gray-200 size-20 dark:text-gray-600"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 18"
      >
        <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
      </svg>
    </div>
    <div className="w-12 h-6 bg-gray-300 rounded-md" />

    <div className="w-full h-4 mt-2 bg-gray-300 rounded-md" />
    <div className="w-3/4 h-4 mt-2 bg-gray-200 rounded-md" />

    <div className="flex items-center justify-center">
      <div className="w-1/3 h-6 my-6 bg-gray-300 rounded-md" />
    </div>
    <div className="flex justify-between gap-4 mt-2">
      <div className="w-3/4 h-10 bg-gray-300 rounded-full" />
      <div className="bg-gray-200 rounded-full size-10 " />
    </div>
  </div>
);
export default ProductCardSkeleton;
